<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="goBack()">
                <ion-icon name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Checker Settings</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content style="background: transparent">

    <p>Here we can add some info for the config checker</p>

    <app-config-checker-auth></app-config-checker-auth>

    <ion-list *ngIf="authService.isLoggedIn$ | async">
        <ion-item>
            <ion-label position="stacked">Current Design</ion-label>
            <ion-input [value]="checkerSettings.designTag" readonly="true"></ion-input>
        </ion-item>

        <ion-item>
            <ion-label>Config Checker Mode</ion-label>
            <ion-select [(ngModel)]="checkerSettings.checkerMode" (ionChange)="updateCheckerMode($event.detail.value)">
                <ion-select-option value="default">Default</ion-select-option>
                <ion-select-option value="sorted">Ordered</ion-select-option>
                <ion-select-option value="appPath">AppPaths</ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item *ngIf="checkerSettings.checkerMode === 'appPath'">
            <ion-label>Select App Path</ion-label>
            <ion-select [(ngModel)]="checkerSettings.selectedAppPath" (ionChange)="updateSelectedAppPath($event.detail.value)">
                <ion-select-option *ngFor="let path of availableAppPaths" [value]="path.name">{{path.name}}</ion-select-option>
            </ion-select>
        </ion-item>


        <ion-item>
            <ion-label>Only Rendered</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.onlyRendered" (ionChange)="updateOnlyRendered($event.detail.checked)"></ion-checkbox>
        </ion-item>

        <ion-item>
            <ion-label>Only New Pages</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.onlyNewPages" (ionChange)="updateOnlyNewPages($event.detail.checked)"></ion-checkbox>
        </ion-item>

        <ion-item>
            <ion-label>Only Reached Pages</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.onlyReachedPages" (ionChange)="updateOnlyReachedPages($event.detail.checked)"></ion-checkbox>
        </ion-item>

        <ion-item>
            <ion-label>Only Dead Ends</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.onlyDeadEnds" (ionChange)="updateOnlyDeadEnds($event.detail.checked)"></ion-checkbox>
        </ion-item>

        <ion-item>
            <ion-label>Enable Metric Overview Page in PDF</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.enableMetricOverviewPage" (ionChange)="updateEnableMetricOverviewPage($event.detail.checked)"></ion-checkbox>
        </ion-item>

        <ion-item>
            <ion-label>Enable Metric Info Page in PDF</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.enableMetricInfoPage" (ionChange)="updateEnableMetricInfoPage($event.detail.checked)"></ion-checkbox>
        </ion-item>

        <ion-item>
            <ion-label>Enable Comparison</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.enableComparison" (ionChange)="updateEnableComparison($event.detail.checked)"></ion-checkbox>
        </ion-item>


        <ion-item *ngIf="checkerSettings.enableComparison">
            <ion-label>Only Changed</ion-label>
            <ion-checkbox [(ngModel)]="checkerSettings.onlyChanged" (ionChange)="updateOnlyChanged($event.detail.checked)"></ion-checkbox>
        </ion-item>

        <ion-item *ngIf="checkerSettings.enableComparison">
            <ion-label position="stacked">Compare to Design</ion-label>
            <ion-select [(ngModel)]="checkerSettings.defaultDesignTag" (ionChange)="updateDefaultDesignTag($event.detail.value)">
                <ion-select-option *ngFor="let design of availableDesigns" [value]="design.designTag">{{design.designTag}}</ion-select-option>
            </ion-select>
        </ion-item>
    </ion-list>

    <div *ngIf="authService.isLoggedIn$ | async" style="padding: 16px; display: flex; flex-direction: column; gap: 8px;">
        <ion-button (click)="openChecker(false)">Generate PDF</ion-button>
        <ion-button (click)="openChecker(true)">Open Checker in View Mode</ion-button>
    </div>
</ion-content>
